angular.module("Finance")
    .controller("missingOracleCodeController", [
        "$scope", "$sessionStorage", "$http", "$activity", "$notification", "$state", "$fileService", "$oidc",
        function ($scope, $sessionStorage, $http, $activity, $notification, $state, $fileService, oidc) {
            $scope.orderName = 'DisplayName';
            $scope.reverse = true;

            $scope.getMissingCodes = function () {
                $activity.start();
                $http
                    .get("/api/party/missing-codes/", {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.list = response.data;
                    }, function (response) {
                        $notification.addError(response.statusText);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            $scope.getMissingCodes();

            $scope.sorting = function (orderName) {
                $scope.reverse = ($scope.orderName === orderName) ? !$scope.reverse : false;
                $scope.orderName = orderName;
            };

            $scope.sortingClass = function (orderName) {
                if ($scope.orderName === orderName) {
                    if ($scope.reverse) {
                        return "fa fa-caret-down";
                    } else {
                        return "fa fa-caret-up";
                    }
                } else {
                    return "";
                }
            };

            $scope.save = function () {
                $activity.start();
                $http
                    .put("/api/party/missing-codes/", $scope.list, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.list = response.data;
                    }, function (response) {
                        $notification.addError(response.statusText);
                    }).then(function () {
                        $activity.finish();
                    });
            };
        }
    ]);